"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRange = generateRange;
const range = (start, end, step) => Array.from({ length: Math.ceil((end - start) / step) }, (_, i) => start + i * step);
/**
 * Return a generator yielding a sequence of numbers from [start, maximum).
 *
 * @param {IGenerateRange}  - options
 *
 * @returns {Generator<number>} - delaySeconds
 *
 */
function* generateRange({ start = 0, stop, step = 1, cycle = false, }) {
    const values = range(start, stop, step);
    if (values.length < 1) {
        // short circuit if there are no values in the range
        return;
    }
    while (true) {
        for (const value of values) {
            yield value;
        }
        if (!cycle) {
            return;
        }
    }
}
//# sourceMappingURL=iterate.js.map